<template>
  <O3D>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { loadFBX } from '../../Reusable/loadFBX'
// import { LinearEncoding, MeshBasicMaterial } from 'three'
// import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js'

export default {
  mixins: [O3DG2],
  mounted () {
    window.addEventListener('keydown', (ev) => {
      if (ev.shiftKey) {
        this.isShift = true
      }
    })
    window.addEventListener('keyup', () => {
      this.isShift = false
    })
    // this.url = require('file-loader!./fbx/iso-city.fbx')

    // // let download = (obj) => {
    // //   return new Promise((resolve) => {
    // //     var gltfExporter = new GLTFExporter();
    // //     var options = {
    // //       binary: true,
    // //     };
    // //     var link = document.createElement('a')
    // //     link.style.display = 'none';
    // //     document.body.appendChild( link ); // Firefox workaround, see #6594
    // //     function save ( blob, filename ) {
    // //       link.href = URL.createObjectURL( blob );
    // //       link.download = filename;
    // //       link.click();
    // //       // URL.revokeObjectURL( url ); breaks Firefox...
    // //     }
    // //     function saveArrayBuffer( buffer, filename ) {
    // //       save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
    // //     }
    // //     function saveString( text, filename ) {
    // //       save( new Blob( [ text ], { type: 'text/plain' } ), filename );
    // //     }

    // //     gltfExporter.parse(obj, function ( result ) {
    // //       if ( result instanceof ArrayBuffer ) {
    // //         saveArrayBuffer(result, obj.downloadName + '.glb');
    // //       } else {
    // //         var output = JSON.stringify(result, null, 2);
    // //         console.log(output);
    // //         saveString(output, obj.downloadName + '.gltf');
    // //       }
    // //       resolve()
    // //     }, options );
    // //   })
    // // }

    // loadFBX(this.url)
    //   .then(e => {
    //     // this.ctx.element.addEventListener('click', async () => {
    //     //   let types = e.children
    //     //   let tsk = []
    //     //   for (let tkn in types) {
    //     //     let type = types[tkn]
    //     //     type.traverse(g => {
    //     //       if (g.isGroup) {
    //     //         console.log('type:', type.name, 'object:', g.name)
    //     //         g.downloadName = `TYPE-${type.name}-OBJECT-${g.name}`
    //     //         tsk.push(async () => {
    //     //           return await download(g)
    //     //         })
    //     //       }
    //     //     })
    //     //   }
    //     //   for (let tskn in tsk) {
    //     //     await tsk[tskn]()
    //     //   }
    //     // })

    //     this.ctx.element.addEventListener('click', async () => {
    //       let types = e.children
    //       let tsk = []
    //       for (let tkn in types) {
    //         let type = types[tkn]
    //         type.traverse(g => {
    //           if (g.isMesh) {
    //             console.log('type:', type.name, 'object:', g.name)
    //             g.downloadName = `TYPE-${type.name}-OBJECT-${g.name}`
    //             tsk.push(async () => {
    //               // return await download(g)
    //             })
    //           }
    //         })
    //       }
    //       for (let tskn in tsk) {
    //         await tsk[tskn]()
    //       }
    //     })

    //     // let white = new Color(0xffffff)
    //     // let red = new Color(0xff0000)
    //     e.traverse(n => {
    //       // console.log(n)
    //       let item = n
    //       if (item.isMesh) {
    //         // console.log(item.material.name, item.material)
    //         let oMat = item.material
    //         item.material = new MeshBasicMaterial({ color: oMat.color, map: oMat.map })

    //         if (item.material.map) {
    //           item.material.map.encoding = LinearEncoding
    //         }
    //         if (item.material.alphaMap) {
    //           item.material.alphaMap.encoding = LinearEncoding
    //         }
    //         if (item.material.metalnessMap) {
    //           item.material.metalnessMap.encoding = LinearEncoding
    //         }
    //         if (item.material.normalMap) {
    //           item.material.normalMap.encoding = LinearEncoding
    //         }
    //         if (item.material.roughnessMap) {
    //           item.material.roughnessMap.encoding = LinearEncoding
    //         }

    //       }
    //     })
    //     this.o3d.add(e)
    //   })
  }
}
</script>

<style>

</style>